var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-outline-rounded small text-center view-all",on:{"click":_vm.deregister}},[_vm._v("\n    Deregister\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }